export default "__VITE_ASSET__RJ1uY_V6__"